import Vue from 'vue';
import VueRouter from 'vue-router';
import HomeDe from '../views/HomeDe.vue';
import HomeEn from '../views/HomeEn.vue';
import Legals from '../views/Legals.vue';
import Privacy from '../views/Privacy.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'HomeDe',
    component: HomeDe,
    meta: {
      title: 'Tricto Samurai - Kartenspiel',
      metaTags: [
        {
          name: 'description',
          content: 'Tricto Samurai, das Kartenspiel für 2 - 6 Spieler. Werde Kaiser im alten Japan.'
        }
      ]
    }
    
  },
  {
    path: '/en',
    name: 'HomeEn',
    component: HomeEn,
    meta: {
      title: 'Tricto Samurai - Cardgame',
      metaTags: [
        {
          name: 'description',
          content: 'Tricto Samurai, the cardgame for 2 - 6 player. Become Emperor in medieveal Japan.'
        }
      ]
    }
  },
  {
    path: '/impressum',
    name: 'Legals',
    component: Legals,
  },
  {
    path: '/datenschutz',
    name: 'Privacy',
    component: Privacy,
  },
];



const router = new VueRouter({
  mode: 'history',
  routes,
});


// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map((el: any) => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map((tagDef:any) => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
  .forEach((tag: any) => document.head.appendChild(tag));

  next();
});

export default router;
